const { Avatar, withStyles } = window.Material;

interface AvatarProps {
  alt?: string;
  src?: string;
  styles?: any;
  classes?: any;
}

const styles = {};

class AvatarE extends React.PureComponent<AvatarProps, {}> {
  render() {
    const { alt, src, classes } = this.props;
    return <Avatar classes={classes} src={src} alt={alt} />;
  }
}

export default withStyles(styles)(AvatarE);
